import { useTranslation } from "react-i18next";
import { convertNumberFormat, leasingDisclaimer } from "../../utils";
import SVGSelector from "../common-components/SVGSelector";
import { useSelector } from "react-redux";
import CustomModal from "../common-components/CustomModal";
import { useState } from "react";
import StyledListItem from "../TabsView/StyledListItem";
import LeasingTabView from "../TabsView/LeasingTabView";

const VehicleListLeasingPriceAndBtn = ({
  leasingOptions,
  manufacturer,
  model,
  priceDetails,
  wrapperClassName,
  internalClassName,
  pClassName,
  supClassName,
}) => {
  const { t } = useTranslation();
  const { uiConfigData = false } = useSelector((state) => state.uiConfig);
  const { i18n = false } = uiConfigData || {};
  const { currencySymbol = false, locales = false } = i18n || {};
  const currency = { currencySymbol, locale: locales?.[0] };
  const [isModalVisible, setIsModalVisible] = useState(false);
  const handleModalToggle = () => {
    setIsModalVisible(!isModalVisible);
  };
  return (
    <>
      {leasingOptions && leasingOptions?.[0]?.instalment ? (
        <div className={wrapperClassName}>
          <div className={internalClassName}>
            {convertNumberFormat(leasingOptions?.[0]?.instalment, currency)}
            <sup
              className={supClassName}
              onClick={(evt) => {
                evt.stopPropagation();
                evt.preventDefault();
                handleModalToggle();
              }}
              title={t("/vehicles.Click here for more info on leasing")}
            >
              <SVGSelector name="i-info-svg" />
            </sup>
          </div>
          <p className={pClassName}>
            <span>{t("/vehicles.Leases/month")}</span>
          </p>
        </div>
      ) : null}

      {isModalVisible && (
        <CustomModal
          isVisible={isModalVisible}
          handleModalToggle={handleModalToggle}
          modalHeader={t("/vehicles.Leasing")}
          modalContent={
            <div className="p-4">
              {" "}
              <StyledListItem
                label={`${t("/vehicleDetails.Leasing example from")} ${leasingOptions?.[0]?.nameOfBank}`}
                value={`${manufacturer?.resourceName} ${model?.name}`}
              />
              <LeasingTabView
                modalView={true}
                leasingOptions={leasingOptions}
                priceDetails={priceDetails}
                currency={currency}
              />
              <div className="text-[var(--davy-gray-color)] text-sm pt-8">
                {leasingDisclaimer({
                  t,
                  nameOfBank: leasingOptions?.[0]?.nameOfBank,
                })}
              </div>
            </div>
          }
          height="h-[80vh]"
        />
      )}
    </>
  );
};
export default VehicleListLeasingPriceAndBtn;
